<ng-container *ngIf="isLoading$ | async">
</ng-container>
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2> {{'MENU.SOCIALMEDIA' | translate}} </h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.SOCIALMEDIA' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="location-area">
    <div class="container">
        <div class="row location-wrap text-center">
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item FbSocialMediaItem" >
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.faceBook" target="FaceBook">
                            <span  [inlineSVG]="'./assets/media/svg/icons/System/icons8-facebook.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.instagram" target="Instagram">
                            <span [inlineSVG]="'./assets/media/svg/icons/System/icons8-instagram.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item TwSocialMediaItem">
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.twitter" target="Twitter">
                            <span [inlineSVG]="'./assets/media/svg/icons/System/icons8-twitter.svg'" cacheSVG="true"
                            class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.snapchat"
                        target="Snapchat"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-snapchat.svg'" cacheSVG="true"
                        class="svg-icon svg-icon-3x "></span>
                        </a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item" >
                    <li style="list-style: none !important;">
                        <a [href]="WhatsAppNo" target="FaceBook">
                            <span  [inlineSVG]="'./assets/media/svg/icons/System/icons8-whatsapp.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.linkedIn"
                            target="LinkedIn"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-linkedin.svg'" cacheSVG="true"
                            class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 wow animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.youTube" target="YouTube"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-youtube.svg'" cacheSVG="true"
                        class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
        </div>
    </div>
</div>